import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";

export default function GaugeChartCard(props) {
  const { name, value, caption, fontSize = 32, height = 150 } = props;
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack
          direction="column"
          sx={{ justifyContent: "space-between", flexGrow: "1", gap: 1 }}
        >
          <Stack sx={{ justifyContent: "space-between" }}>
            <Stack
              direction="column"
              sx={{
                alignItems: "center",
              }}
            >
              <Typography noWrap align={"center"} variant="p">
                {name}
              </Typography>
            </Stack>
          </Stack>
          <Box
            sx={{
              width: "100%",
              minHeight: 100,
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {value ? (
              <Gauge
                value={value}
                startAngle={-110}
                endAngle={110}
                height={height}
                sx={{
                  [`& .${gaugeClasses.valueText}`]: {
                    fontSize: fontSize,
                    transform: "translate(0px, 0px)",
                  },
                }}
                text={({ value, valueMax }) => `${value.toFixed(1)}%`}
              />
            ) : (
              <CircularProgress></CircularProgress>
            )}
          </Box>
          <Stack sx={{ justifyContent: "space-between" }}>
            <Stack
              direction="column"
              sx={{
                alignItems: "center",
              }}
            >
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {caption}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
